export const DashboardCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8005)">
                <path
                    d="M22.75 17.5H18.25C17.8358 17.5 17.5 17.8358 17.5 18.25V22.75C17.5 23.1642 17.8358 23.5 18.25 23.5H22.75C23.1642 23.5 23.5 23.1642 23.5 22.75V18.25C23.5 17.8358 23.1642 17.5 22.75 17.5Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M31.75 17.5H27.25C26.8358 17.5 26.5 17.8358 26.5 18.25V22.75C26.5 23.1642 26.8358 23.5 27.25 23.5H31.75C32.1642 23.5 32.5 23.1642 32.5 22.75V18.25C32.5 17.8358 32.1642 17.5 31.75 17.5Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M22.75 26.5H18.25C17.8358 26.5 17.5 26.8358 17.5 27.25V31.75C17.5 32.1642 17.8358 32.5 18.25 32.5H22.75C23.1642 32.5 23.5 32.1642 23.5 31.75V27.25C23.5 26.8358 23.1642 26.5 22.75 26.5Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M31.75 26.5H27.25C26.8358 26.5 26.5 26.8358 26.5 27.25V31.75C26.5 32.1642 26.8358 32.5 27.25 32.5H31.75C32.1642 32.5 32.5 32.1642 32.5 31.75V27.25C32.5 26.8358 32.1642 26.5 31.75 26.5Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_709_8005">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ProductTypesCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8016)">
                <path
                    d="M25 25.1023V34.7473"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16.0656 20.2112L25 25.1012L33.9344 20.2112"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M33.61 30.1413L25.36 34.6581C25.2496 34.7185 25.1258 34.7502 25 34.7502C24.8742 34.7502 24.7504 34.7185 24.64 34.6581L16.39 30.1413C16.2722 30.0768 16.1739 29.9819 16.1053 29.8665C16.0367 29.751 16.0003 29.6193 16 29.485V20.5169C16.0003 20.3826 16.0367 20.2509 16.1053 20.1354C16.1739 20.02 16.2722 19.9251 16.39 19.8606L24.64 15.3438C24.7504 15.2834 24.8742 15.2517 25 15.2517C25.1258 15.2517 25.2496 15.2834 25.36 15.3438L33.61 19.8606C33.7278 19.9251 33.8261 20.02 33.8947 20.1354C33.9633 20.2509 33.9997 20.3826 34 20.5169V29.4831C34 29.6177 33.9638 29.7499 33.8952 29.8657C33.8266 29.9815 33.7281 30.0766 33.61 30.1413Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_709_8016">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const SupplierTypesCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8026)">
                <path
                    d="M25 28C28.3137 28 31 25.3137 31 22C31 18.6863 28.3137 16 25 16C21.6863 16 19 18.6863 19 22C19 25.3137 21.6863 28 25 28Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 33.25C17.8159 30.1122 21.1141 28 25 28C28.8859 28 32.1841 30.1122 34 33.25"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_709_8026">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const CustomerCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clipPath="url(#clip0_customer_card)">
                {/* Head */}
                <circle cx="25" cy="21" r="5" stroke="#ED2024" strokeWidth="1.5" fill="none" />
                {/* Shoulders/Body */}
                <path
                    d="M15 34C16.3333 30.6667 19.3889 29 25 29C30.6111 29 33.6667 30.6667 35 34"
                    stroke="#ED2024"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </g>
            <defs>
                <clipPath id="clip0_customer_card">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const CertifiedByCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8035)">
                <path
                    d="M19.75 25.75H24.25"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.75 22.75H29.5"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.75 31H16.75C16.5511 31 16.3603 30.921 16.2197 30.7803C16.079 30.6397 16 30.4489 16 30.25V18.25C16 18.0511 16.079 17.8603 16.2197 17.7197C16.3603 17.579 16.5511 17.5 16.75 17.5H33.25C33.4489 17.5 33.6397 17.579 33.7803 17.7197C33.921 17.8603 34 18.0511 34 18.25V21.4431"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M34 21V30C34 30.5523 33.5523 31 33 31H28" stroke="#ED2024" stroke-width="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_709_8035">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const ProductTypeImageCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8046)">
                <path
                    d="M33.25 17.5H16.75C16.3358 17.5 16 17.8358 16 18.25V31.75C16 32.1642 16.3358 32.5 16.75 32.5H33.25C33.6642 32.5 34 32.1642 34 31.75V18.25C34 17.8358 33.6642 17.5 33.25 17.5Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M26.8103 28.3751L29.2187 25.9695C29.3594 25.829 29.5501 25.75 29.7489 25.75C29.9477 25.75 30.1384 25.829 30.2791 25.9695L34 29.6932"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 28.8148L21.0944 23.7195C21.164 23.6497 21.2467 23.5944 21.3378 23.5567C21.4288 23.5189 21.5264 23.4995 21.625 23.4995C21.7236 23.4995 21.8212 23.5189 21.9122 23.5567C22.0033 23.5944 22.086 23.6497 22.1556 23.7195L30.9353 32.5001"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_709_8046">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DashboardIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.875 3.4375C6.19513 3.4375 5.53052 3.63911 4.96523 4.01682C4.39993 4.39454 3.95934 4.93141 3.69917 5.55953C3.43899 6.18765 3.37092 6.87881 3.50355 7.54562C3.63619 8.21243 3.96358 8.82494 4.44432 9.30568C4.92507 9.78642 5.53757 10.1138 6.20438 10.2465C6.87119 10.3791 7.56235 10.311 8.19048 10.0508C8.8186 9.79066 9.35546 9.35007 9.73318 8.78477C10.1109 8.21948 10.3125 7.55487 10.3125 6.875C10.3125 5.96332 9.95034 5.08898 9.30568 4.44432C8.66102 3.79967 7.78668 3.4375 6.875 3.4375ZM6.875 8.9375C6.46708 8.9375 6.06831 8.81654 5.72914 8.58991C5.38996 8.36328 5.12561 8.04116 4.9695 7.66429C4.81339 7.28741 4.77255 6.87271 4.85213 6.47263C4.93171 6.07254 5.12815 5.70504 5.41659 5.41659C5.70504 5.12815 6.07254 4.93171 6.47263 4.85213C6.87271 4.77255 7.28741 4.81339 7.66429 4.9695C8.04116 5.12561 8.36328 5.38996 8.58991 5.72914C8.81654 6.06831 8.9375 6.46708 8.9375 6.875C8.9375 7.42201 8.7202 7.94662 8.33341 8.33341C7.94662 8.7202 7.42201 8.9375 6.875 8.9375ZM15.125 10.3125C15.8049 10.3125 16.4695 10.1109 17.0348 9.73318C17.6001 9.35546 18.0407 8.8186 18.3008 8.19048C18.561 7.56235 18.6291 6.87119 18.4965 6.20438C18.3638 5.53757 18.0364 4.92507 17.5557 4.44432C17.0749 3.96358 16.4624 3.63619 15.7956 3.50355C15.1288 3.37092 14.4376 3.43899 13.8095 3.69917C13.1814 3.95934 12.6445 4.39993 12.2668 4.96523C11.8891 5.53052 11.6875 6.19513 11.6875 6.875C11.6875 7.78668 12.0497 8.66102 12.6943 9.30568C13.339 9.95034 14.2133 10.3125 15.125 10.3125ZM15.125 4.8125C15.5329 4.8125 15.9317 4.93347 16.2709 5.1601C16.61 5.38673 16.8744 5.70884 17.0305 6.08572C17.1866 6.46259 17.2275 6.87729 17.1479 7.27738C17.0683 7.67746 16.8719 8.04496 16.5834 8.33341C16.295 8.62186 15.9275 8.81829 15.5274 8.89787C15.1273 8.97745 14.7126 8.93661 14.3357 8.7805C13.9588 8.6244 13.6367 8.36004 13.4101 8.02087C13.1835 7.68169 13.0625 7.28293 13.0625 6.875C13.0625 6.32799 13.2798 5.80339 13.6666 5.41659C14.0534 5.0298 14.578 4.8125 15.125 4.8125ZM6.875 11.6875C6.19513 11.6875 5.53052 11.8891 4.96523 12.2668C4.39993 12.6445 3.95934 13.1814 3.69917 13.8095C3.43899 14.4376 3.37092 15.1288 3.50355 15.7956C3.63619 16.4624 3.96358 17.0749 4.44432 17.5557C4.92507 18.0364 5.53757 18.3638 6.20438 18.4965C6.87119 18.6291 7.56235 18.561 8.19048 18.3008C8.8186 18.0407 9.35546 17.6001 9.73318 17.0348C10.1109 16.4695 10.3125 15.8049 10.3125 15.125C10.3125 14.2133 9.95034 13.339 9.30568 12.6943C8.66102 12.0497 7.78668 11.6875 6.875 11.6875ZM6.875 17.1875C6.46708 17.1875 6.06831 17.0665 5.72914 16.8399C5.38996 16.6133 5.12561 16.2912 4.9695 15.9143C4.81339 15.5374 4.77255 15.1227 4.85213 14.7226C4.93171 14.3225 5.12815 13.955 5.41659 13.6666C5.70504 13.3781 6.07254 13.1817 6.47263 13.1021C6.87271 13.0225 7.28741 13.0634 7.66429 13.2195C8.04116 13.3756 8.36328 13.64 8.58991 13.9791C8.81654 14.3183 8.9375 14.7171 8.9375 15.125C8.9375 15.672 8.7202 16.1966 8.33341 16.5834C7.94662 16.9702 7.42201 17.1875 6.875 17.1875ZM15.125 11.6875C14.4451 11.6875 13.7805 11.8891 13.2152 12.2668C12.6499 12.6445 12.2093 13.1814 11.9492 13.8095C11.689 14.4376 11.6209 15.1288 11.7536 15.7956C11.8862 16.4624 12.2136 17.0749 12.6943 17.5557C13.1751 18.0364 13.7876 18.3638 14.4544 18.4965C15.1212 18.6291 15.8124 18.561 16.4405 18.3008C17.0686 18.0407 17.6055 17.6001 17.9832 17.0348C18.3609 16.4695 18.5625 15.8049 18.5625 15.125C18.5625 14.2133 18.2003 13.339 17.5557 12.6943C16.911 12.0497 16.0367 11.6875 15.125 11.6875ZM15.125 17.1875C14.7171 17.1875 14.3183 17.0665 13.9791 16.8399C13.64 16.6133 13.3756 16.2912 13.2195 15.9143C13.0634 15.5374 13.0225 15.1227 13.1021 14.7226C13.1817 14.3225 13.3781 13.955 13.6666 13.6666C13.955 13.3781 14.3225 13.1817 14.7226 13.1021C15.1227 13.0225 15.5374 13.0634 15.9143 13.2195C16.2912 13.3756 16.6133 13.64 16.8399 13.9791C17.0665 14.3183 17.1875 14.7171 17.1875 15.125C17.1875 15.672 16.9702 16.1966 16.5834 16.5834C16.1966 16.9702 15.672 17.1875 15.125 17.1875Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const RegionsIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 2.75005L17.9042 6.5313L15.3459 7.93208L8.44078 4.15083L11 2.75005ZM11 10.3125L4.09578 6.5313L7.00906 4.9363L13.9133 8.71755L11 10.3125ZM3.4375 7.73442L10.3125 11.4968V18.8693L3.4375 15.1096V7.73442ZM18.5625 15.1061L11.6875 18.8693V11.5002L14.4375 9.99544V13.0625C14.4375 13.2449 14.5099 13.4198 14.6389 13.5487C14.7678 13.6776 14.9427 13.75 15.125 13.75C15.3073 13.75 15.4822 13.6776 15.6111 13.5487C15.7401 13.4198 15.8125 13.2449 15.8125 13.0625V9.24262L18.5625 7.73442V15.1053V15.1061Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const ProductsIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Box base */}
            <rect
                x="4"
                y="7"
                width="14"
                height="9"
                rx="2"
                fill={active ? "#ED2024" : "#E0E0E0"}
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.2"
            />
            {/* Box lid */}
            <rect
                x="5.5"
                y="5"
                width="11"
                height="3"
                rx="1"
                fill={active ? "#FFF0F0" : "#F5F5F5"}
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.2"
            />
            {/* Handle */}
            <rect x="10" y="10.5" width="2" height="3" rx="1" fill={active ? "#ED2024" : "#BDBDBD"} />
        </svg>
    );
};

export const UsersIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.5 7.33333C16.5 9.17428 15.0074 10.6667 13.1667 10.6667C11.3259 10.6667 9.83333 9.17428 9.83333 7.33333C9.83333 5.49238 11.3259 4 13.1667 4C15.0074 4 16.5 5.49238 16.5 7.33333Z"
                stroke={active ? "#ED2024" : "#575757"}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M13.1667 12.6667C10.3883 12.6667 8.16667 14.8883 8.16667 17.6667"
                stroke={active ? "#ED2024" : "#575757"}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M5.5 7.33333C5.5 9.17428 6.99262 10.6667 8.83333 10.6667"
                stroke={active ? "#ED2024" : "#575757"}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8.83333 12.6667C6.05495 12.6667 3.83333 14.8883 3.83333 17.6667"
                stroke={active ? "#ED2024" : "#575757"}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export const PackageIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.2225 5.68481L11.66 1.54692C11.4579 1.43527 11.2309 1.37671 11 1.37671C10.7691 1.37671 10.5421 1.43527 10.34 1.54692L2.7775 5.68653C2.56153 5.8047 2.38125 5.97868 2.25547 6.19032C2.1297 6.40195 2.06306 6.64347 2.0625 6.88966V15.1087C2.06306 15.3549 2.1297 15.5964 2.25547 15.8081C2.38125 16.0197 2.56153 16.1937 2.7775 16.3118L10.34 20.4515C10.5421 20.5631 10.7691 20.6217 11 20.6217C11.2309 20.6217 11.4579 20.5631 11.66 20.4515L19.2225 16.3118C19.4385 16.1937 19.6188 16.0197 19.7445 15.8081C19.8703 15.5964 19.9369 15.3549 19.9375 15.1087V6.89051C19.9374 6.64389 19.871 6.40184 19.7452 6.18971C19.6194 5.97758 19.4389 5.80319 19.2225 5.68481ZM11 2.75005L17.9042 6.5313L15.3459 7.93208L8.44078 4.15083L11 2.75005ZM11 10.3125L4.09578 6.5313L7.00906 4.9363L13.9133 8.71755L11 10.3125ZM3.4375 7.73442L10.3125 11.4968V18.8693L3.4375 15.1096V7.73442ZM18.5625 15.1061L11.6875 18.8693V11.5002L14.4375 9.99544V13.0625C14.4375 13.2449 14.5099 13.4198 14.6389 13.5487C14.7678 13.6776 14.9427 13.75 15.125 13.75C15.3073 13.75 15.4822 13.6776 15.6111 13.5487C15.7401 13.4198 15.8125 13.2449 15.8125 13.0625V9.24262L18.5625 7.73442V15.1053V15.1061Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const OrdersIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Shopping cart base */}
            <path
                d="M7 4V2C7 1.45 7.45 1 8 1H14C14.55 1 15 1.45 15 2V4H18C18.55 4 19 4.45 19 5S18.55 6 18 6H17V18C17 19.1 16.1 20 15 20H7C5.9 20 5 19.1 5 18V6H4C3.45 6 3 5.55 3 5S3.45 4 4 4H7ZM9 3V4H13V3H9ZM7 6V18H15V6H7Z"
                fill={active ? "#ED2024" : "#575757"}
            />
            {/* Order lines */}
            <rect x="8" y="8" width="6" height="1" rx="0.5" fill={active ? "#ED2024" : "#575757"} opacity="0.7" />
            <rect x="8" y="10" width="4" height="1" rx="0.5" fill={active ? "#ED2024" : "#575757"} opacity="0.5" />
            <rect x="8" y="12" width="5" height="1" rx="0.5" fill={active ? "#ED2024" : "#575757"} opacity="0.5" />
            {/* Status indicator */}
            <circle cx="16" cy="6" r="2" fill={active ? "#ED2024" : "#575757"} opacity="0.3" />
            <circle cx="16" cy="6" r="1" fill={active ? "#ED2024" : "#575757"} />
        </svg>
    );
};

export const PencilIcon = (active) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.0293 6.26615L13.7341 2.97022C13.6245 2.86062 13.4944 2.77368 13.3512 2.71436C13.208 2.65504 13.0546 2.62451 12.8996 2.62451C12.7446 2.62451 12.5911 2.65504 12.448 2.71436C12.3048 2.77368 12.1747 2.86062 12.0651 2.97022L2.9709 12.0652C2.86085 12.1743 2.77359 12.3043 2.71421 12.4475C2.65483 12.5907 2.62451 12.7443 2.62501 12.8993V16.1952C2.62501 16.5082 2.74933 16.8083 2.97062 17.0296C3.19192 17.2509 3.49206 17.3752 3.80502 17.3752H7.10094C7.25596 17.3757 7.40953 17.3454 7.55272 17.286C7.69592 17.2266 7.82588 17.1394 7.93506 17.0293L17.0293 7.93513C17.1389 7.82555 17.2258 7.69545 17.2851 7.55227C17.3444 7.40909 17.375 7.25562 17.375 7.10064C17.375 6.94565 17.3444 6.79219 17.2851 6.649C17.2258 6.50582 17.1389 6.37572 17.0293 6.26615ZM7.10094 16.1952H3.80502V12.8993L10.2951 6.40922L13.591 9.70514L7.10094 16.1952ZM14.4251 8.87029L11.1292 5.5751L12.8992 3.80508L16.1951 7.10027L14.4251 8.87029Z"
                fill="#454545"
            />
        </svg>
    );
};
export const WarningIcon = () => {
    return (
        <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_875_8803)">
                <path
                    d="M18.4995 31.5002C25.9554 31.5002 31.9995 25.4561 31.9995 18.0002C31.9995 10.5444 25.9554 4.50024 18.4995 4.50024C11.0437 4.50024 4.99951 10.5444 4.99951 18.0002C4.99951 25.4561 11.0437 31.5002 18.4995 31.5002Z"
                    stroke="#F78F08"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M17.375 16.875C17.6734 16.875 17.9595 16.9935 18.1705 17.2045C18.3815 17.4155 18.5 17.7016 18.5 18V23.625C18.5 23.9234 18.6185 24.2095 18.8295 24.4205C19.0405 24.6315 19.3266 24.75 19.625 24.75"
                    stroke="#F78F08"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M17.9373 13.5C18.8692 13.5 19.6248 12.7445 19.6248 11.8125C19.6248 10.8805 18.8692 10.125 17.9373 10.125C17.0053 10.125 16.2498 10.8805 16.2498 11.8125C16.2498 12.7445 17.0053 13.5 17.9373 13.5Z"
                    fill="#F78F08"
                />
            </g>
            <defs>
                <clipPath id="clip0_875_8803">
                    <rect width="36" height="36" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ContentIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.3834 6.59745L12.2103 2.42438C12.1549 2.36903 12.0891 2.32515 12.0168 2.29523C11.9444 2.26531 11.8668 2.24994 11.7885 2.25H4.63469C4.31847 2.25 4.0152 2.37562 3.7916 2.59922C3.568 2.82282 3.44238 3.12609 3.44238 3.44231V16.5577C3.44238 16.8739 3.568 17.1772 3.7916 17.4008C4.0152 17.6244 4.31847 17.75 4.63469 17.75H15.3655C15.6817 17.75 15.9849 17.6244 16.2085 17.4008C16.4321 17.1772 16.5578 16.8739 16.5578 16.5577V7.01923C16.5578 6.94092 16.5425 6.86336 16.5125 6.79099C16.4826 6.71862 16.4387 6.65286 16.3834 6.59745ZM12.3847 4.28512L14.5226 6.42308H12.3847V4.28512ZM15.3655 16.5577H4.63469V3.44231H11.1924V7.01923C11.1924 7.17734 11.2552 7.32897 11.367 7.44078C11.4788 7.55258 11.6304 7.61538 11.7885 7.61538H15.3655V16.5577ZM12.9808 10.5962C12.9808 10.7543 12.918 10.9059 12.8062 11.0177C12.6944 11.1295 12.5428 11.1923 12.3847 11.1923H7.61546C7.45735 11.1923 7.30572 11.1295 7.19392 11.0177C7.08211 10.9059 7.01931 10.7543 7.01931 10.5962C7.01931 10.438 7.08211 10.2864 7.19392 10.1746C7.30572 10.0628 7.45735 10 7.61546 10H12.3847C12.5428 10 12.6944 10.0628 12.8062 10.1746C12.918 10.2864 12.9808 10.438 12.9808 10.5962ZM12.9808 12.9808C12.9808 13.1389 12.918 13.2905 12.8062 13.4023C12.6944 13.5141 12.5428 13.5769 12.3847 13.5769H7.61546C7.45735 13.5769 7.30572 13.5141 7.19392 13.4023C7.08211 13.2905 7.01931 13.1389 7.01931 12.9808C7.01931 12.8227 7.08211 12.671 7.19392 12.5592C7.30572 12.4474 7.45735 12.3846 7.61546 12.3846H12.3847C12.5428 12.3846 12.6944 12.4474 12.8062 12.5592C12.918 12.671 12.9808 12.8227 12.9808 12.9808Z"
                fill="#454545"
            />
        </svg>
    );
};

export const AssignmentIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Document/Assignment icon */}
            <rect
                x="5"
                y="3"
                width="12"
                height="16"
                rx="1"
                fill={active ? "#ED2024" : "#E0E0E0"}
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.2"
            />
            {/* Document lines */}
            <line
                x1="7.5"
                y1="7"
                x2="14.5"
                y2="7"
                stroke={active ? "#FFFFFF" : "#575757"}
                strokeWidth="1"
                strokeLinecap="round"
            />
            <line
                x1="7.5"
                y1="9.5"
                x2="14.5"
                y2="9.5"
                stroke={active ? "#FFFFFF" : "#575757"}
                strokeWidth="1"
                strokeLinecap="round"
            />
            <line
                x1="7.5"
                y1="12"
                x2="12.5"
                y2="12"
                stroke={active ? "#FFFFFF" : "#575757"}
                strokeWidth="1"
                strokeLinecap="round"
            />
            {/* Checkmark or approval mark */}
            <path
                d="M16 5L18 7L16 9"
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export const SupplierIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.625 15.8125H19.9375V4.97581L20.7685 4.79706C20.8587 4.78014 20.9446 4.74534 21.0211 4.69471C21.0977 4.64407 21.1633 4.57863 21.2141 4.50223C21.265 4.42584 21.3 4.34004 21.3172 4.24989C21.3343 4.15975 21.3333 4.06708 21.314 3.97735C21.2948 3.88761 21.2578 3.80264 21.2053 3.72743C21.1527 3.65222 21.0856 3.5883 21.0079 3.53943C20.9302 3.49056 20.8436 3.45774 20.753 3.44289C20.6624 3.42805 20.5698 3.43148 20.4806 3.45299L1.23062 7.57799C1.06479 7.61378 0.918036 7.70962 0.818601 7.84708C0.719167 7.98455 0.67407 8.15392 0.691986 8.32263C0.709902 8.49133 0.789565 8.64746 0.915652 8.76097C1.04174 8.87448 1.20534 8.93737 1.375 8.93753C1.42382 8.93744 1.47249 8.93225 1.52023 8.92206L2.0625 8.80604V15.8125H1.375C1.19266 15.8125 1.0178 15.885 0.888864 16.0139C0.759933 16.1428 0.6875 16.3177 0.6875 16.5C0.6875 16.6824 0.759933 16.8572 0.888864 16.9862C1.0178 17.1151 1.19266 17.1875 1.375 17.1875H20.625C20.8073 17.1875 20.9822 17.1151 21.1111 16.9862C21.2401 16.8572 21.3125 16.6824 21.3125 16.5C21.3125 16.3177 21.2401 16.1428 21.1111 16.0139C20.9822 15.885 20.8073 15.8125 20.625 15.8125ZM3.4375 8.50784L18.5625 5.27057V15.8125H16.5V11C16.5 10.8177 16.4276 10.6428 16.2986 10.5139C16.1697 10.385 15.9948 10.3125 15.8125 10.3125H6.1875C6.00516 10.3125 5.8303 10.385 5.70136 10.5139C5.57243 10.6428 5.5 10.8177 5.5 11V15.8125H3.4375V8.50784ZM15.125 13.0625H6.875V11.6875H15.125V13.0625ZM6.875 14.4375H15.125V15.8125H6.875V14.4375Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const CertifiedIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 11.6875C11 11.8698 10.9276 12.0447 10.7986 12.1736C10.6697 12.3026 10.4948 12.375 10.3125 12.375H6.1875C6.00516 12.375 5.8303 12.3026 5.70136 12.1736C5.57243 12.0447 5.5 11.8698 5.5 11.6875C5.5 11.5052 5.57243 11.3303 5.70136 11.2014C5.8303 11.0724 6.00516 11 6.1875 11H10.3125C10.4948 11 10.6697 11.0724 10.7986 11.2014C10.9276 11.3303 11 11.5052 11 11.6875ZM10.3125 8.25H6.1875C6.00516 8.25 5.8303 8.32243 5.70136 8.45136C5.57243 8.5803 5.5 8.75516 5.5 8.9375C5.5 9.11984 5.57243 9.2947 5.70136 9.42364C5.8303 9.55257 6.00516 9.625 6.1875 9.625H10.3125C10.4948 9.625 10.6697 9.55257 10.7986 9.42364C10.9276 9.2947 11 9.11984 11 8.9375C11 8.75516 10.9276 8.5803 10.7986 8.45136C10.6697 8.32243 10.4948 8.25 10.3125 8.25ZM19.9375 13.8763V19.25C19.9386 19.3712 19.9076 19.4905 19.8477 19.5959C19.7878 19.7013 19.7011 19.789 19.5964 19.85C19.4917 19.9111 19.3728 19.9434 19.2516 19.9437C19.1303 19.944 19.0112 19.9122 18.9062 19.8516L16.8438 18.6708L14.7812 19.8516C14.6763 19.9122 14.5572 19.944 14.436 19.9437C14.3147 19.9434 14.1958 19.9111 14.0911 19.85C13.9864 19.789 13.8997 19.7013 13.8398 19.5959C13.7799 19.4905 13.7489 19.3712 13.75 19.25V17.1875H3.4375C3.07283 17.1875 2.72309 17.0426 2.46523 16.7848C2.20737 16.5269 2.0625 16.1772 2.0625 15.8125V4.8125C2.0625 4.44783 2.20737 4.09809 2.46523 3.84023C2.72309 3.58237 3.07283 3.4375 3.4375 3.4375H18.5625C18.9272 3.4375 19.2769 3.58237 19.5348 3.84023C19.7926 4.09809 19.9375 4.44783 19.9375 4.8125V7.43617C20.3721 7.85235 20.718 8.3522 20.9542 8.90561C21.1905 9.45901 21.3123 10.0545 21.3123 10.6562C21.3123 11.258 21.1905 11.8535 20.9542 12.4069C20.718 12.9603 20.3721 13.4601 19.9375 13.8763ZM13.75 15.8125V13.8763C13.0008 13.1538 12.5273 12.1924 12.4113 11.1581C12.2952 10.1237 12.5438 9.08128 13.1142 8.21067C13.6847 7.34006 14.5411 6.69587 15.5358 6.38927C16.5304 6.08266 17.6009 6.13288 18.5625 6.53125V4.8125H3.4375V15.8125H13.75ZM18.5625 14.7812C18.018 15.0087 17.4338 15.1259 16.8438 15.1259C16.2537 15.1259 15.6695 15.0087 15.125 14.7812V18.0658L16.5 17.2786C16.6039 17.2192 16.7215 17.188 16.8412 17.188C16.9608 17.188 17.0784 17.2192 17.1823 17.2786L18.5573 18.0658L18.5625 14.7812ZM19.9375 10.6562C19.9375 10.0444 19.7561 9.44622 19.4161 8.93745C19.0762 8.42869 18.593 8.03216 18.0277 7.798C17.4624 7.56384 16.8403 7.50257 16.2402 7.62195C15.6401 7.74132 15.0888 8.03597 14.6561 8.46864C14.2235 8.90131 13.9288 9.45256 13.8094 10.0527C13.6901 10.6528 13.7513 11.2749 13.9855 11.8402C14.2197 12.4055 14.6162 12.8887 15.125 13.2286C15.6337 13.5686 16.2319 13.75 16.8438 13.75C17.25 13.75 17.6523 13.67 18.0277 13.5145C18.403 13.359 18.7441 13.1311 19.0314 12.8439C19.3186 12.5566 19.5465 12.2155 19.702 11.8402C19.8575 11.4648 19.9375 11.0625 19.9375 10.6562Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const MailIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.75 3.375H2.25C2.10082 3.375 1.95774 3.43426 1.85225 3.53975C1.74676 3.64524 1.6875 3.78832 1.6875 3.9375V13.5C1.6875 13.7984 1.80603 14.0845 2.017 14.2955C2.22798 14.5065 2.51413 14.625 2.8125 14.625H15.1875C15.4859 14.625 15.772 14.5065 15.983 14.2955C16.194 14.0845 16.3125 13.7984 16.3125 13.5V3.9375C16.3125 3.78832 16.2532 3.64524 16.1477 3.53975C16.0423 3.43426 15.8992 3.375 15.75 3.375ZM14.3037 4.5L9 9.36211L3.69633 4.5H14.3037ZM15.1875 13.5H2.8125V5.21648L8.61961 10.5398C8.72338 10.6351 8.85913 10.688 9 10.688C9.14087 10.688 9.27662 10.6351 9.38039 10.5398L15.1875 5.21648V13.5Z"
                fill="#131313"
            />
        </svg>
    );
};

export const SalesCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8056)">
                <path
                    d="M16.75 17.5H33.25C33.6642 17.5 34 17.8358 34 18.25V31.75C34 32.1642 33.6642 32.5 33.25 32.5H16.75C16.3358 32.5 16 32.1642 16 31.75V18.25C16 17.8358 16.3358 17.5 16.75 17.5Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 21.25H34"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.5 25.75H29.5"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.5 28.75H26.5"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_709_8056">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const OrdersCardIcon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#FFEAED" />
            <g clip-path="url(#clip0_709_8066)">
                <path
                    d="M19.75 25.75H24.25"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.75 22.75H29.5"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.75 28.75H27.25"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.75 31H16.75C16.5511 31 16.3603 30.921 16.2197 30.7803C16.079 30.6397 16 30.4489 16 30.25V18.25C16 18.0511 16.079 17.8603 16.2197 17.7197C16.3603 17.579 16.5511 17.5 16.75 17.5H33.25C33.4489 17.5 33.6397 17.579 33.7803 17.7197C33.921 17.8603 34 18.0511 34 18.25V30.25C34 30.4489 33.921 30.6397 33.7803 30.7803C33.6397 30.921 33.4489 31 33.25 31H28.75Z"
                    stroke="#ED2024"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_709_8066">
                    <rect width="24" height="24" fill="white" transform="translate(13 13)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const LocationOnIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11 2C8.13 2 6 4.13 6 7C6 11.5 11 19 11 19C11 19 16 11.5 16 7C16 4.13 13.87 2 11 2ZM11 9.5C10.17 9.5 9.5 8.83 9.5 8C9.5 7.17 10.17 6.5 11 6.5C11.83 6.5 12.5 7.17 12.5 8C12.5 8.83 11.83 9.5 11 9.5Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const SecurityIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Shield shape */}
            <path
                d="M11 2L18 4.5V10C18 14.5 14.5 18.5 11 20C7.5 18.5 4 14.5 4 10V4.5L11 2Z"
                fill={active ? "#ED2024" : "#E0E0E0"}
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.2"
            />
            {/* Lock icon inside shield */}
            <path
                d="M8.5 10.5V8.5C8.5 7.4 9.4 6.5 10.5 6.5H11.5C12.6 6.5 13.5 7.4 13.5 8.5V10.5"
                stroke={active ? "#FFFFFF" : "#575757"}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <rect
                x="9"
                y="10.5"
                width="4"
                height="3"
                rx="1"
                fill={active ? "#FFFFFF" : "#575757"}
                stroke={active ? "#FFFFFF" : "#575757"}
                strokeWidth="1.2"
            />
            {/* Checkmark */}
            <path
                d="M10 12.5L11 13.5L13 11.5"
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export const PersonIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Person/User icon */}
            <path
                d="M11 11C13.3012 11 15.1667 9.13452 15.1667 6.83333C15.1667 4.53215 13.3012 2.66667 11 2.66667C8.69879 2.66667 6.83333 4.53215 6.83333 6.83333C6.83333 9.13452 8.69879 11 11 11Z"
                fill={active ? "#ED2024" : "#575757"}
            />
            <path
                d="M11 13.75C7.32031 13.75 4.125 16.9453 4.125 20.625V21.3333C4.125 21.7015 4.42348 22 4.79167 22H17.2083C17.5765 22 17.875 21.7015 17.875 21.3333V20.625C17.875 16.9453 14.6797 13.75 11 13.75Z"
                fill={active ? "#ED2024" : "#575757"}
            />
        </svg>
    );
};

export const ReportsIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Chart/Report icon */}
            <rect
                x="3"
                y="3"
                width="16"
                height="12"
                rx="2"
                fill={active ? "#ED2024" : "#E0E0E0"}
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1.2"
            />
            {/* Chart bars */}
            <rect x="6" y="10" width="2" height="3" fill={active ? "#FFFFFF" : "#575757"} />
            <rect x="9" y="8" width="2" height="5" fill={active ? "#FFFFFF" : "#575757"} />
            <rect x="12" y="6" width="2" height="7" fill={active ? "#FFFFFF" : "#575757"} />
            <rect x="15" y="9" width="2" height="4" fill={active ? "#FFFFFF" : "#575757"} />
            {/* Document lines */}
            <line
                x1="5"
                y1="17"
                x2="17"
                y2="17"
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1"
                strokeLinecap="round"
            />
            <line
                x1="5"
                y1="19"
                x2="14"
                y2="19"
                stroke={active ? "#ED2024" : "#575757"}
                strokeWidth="1"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const AlertsIcon = ({ active }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Bell body */}
            <path
                d="M11 2C8.24 2 6 4.24 6 7V12L4 16H18L16 12V7C16 4.24 13.76 2 11 2Z"
                fill={active ? "#ED2024" : "#575757"}
            />
            {/* Bell clapper */}
            <circle cx="11" cy="18" r="1.5" fill={active ? "#ED2024" : "#575757"} />
            {/* Bell handle */}
            <path
                d="M9 18H13C13.55 18 14 18.45 14 19V20C14 20.55 13.55 21 13 21H9C8.45 21 8 20.55 8 20V19C8 18.45 8.45 18 9 18Z"
                fill={active ? "#ED2024" : "#575757"}
            />
            {/* Notification dot */}
            <circle cx="16" cy="6" r="3" fill="#FF4444" />
            <circle cx="16" cy="6" r="1.5" fill="white" />
        </svg>
    );
};
